<script setup lang="ts">
/**
 * The 16px spinner inside a busy button on the signed-out pages (Sign in, Create workspace, Save
 * and sign in, Sign out). It takes the button's text colour; decorative, so the button's own
 * label ("Signing in…") says what is happening.
 */
</script>

<template>
  <svg class="h-4 w-4 animate-spin" viewBox="0 0 24 24" aria-hidden="true">
    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" fill="none"></circle>
    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
  </svg>
</template>
